import type {CSSProperties} from 'react';
import {getAssetUrl} from '@Utils/s3.util';

export interface TicketingLoginSectionBackgroundStyle extends CSSProperties {
  '--ticketing-login-background-image': string;
}

export const TICKETING_LOGIN_SECTION_BACKGROUND_STYLE: TicketingLoginSectionBackgroundStyle = {
  '--ticketing-login-background-image': `url(${getAssetUrl('ticketing-login-page-bg.webp')})`,
};

export const TICKETING_LOGIN_VISUAL_URL = getAssetUrl('ticketing-login-page-visual-3x.webp');
export const TICKETING_LOGIN_VISUAL_WIDTH = 405;
export const TICKETING_LOGIN_VISUAL_HEIGHT = 418;
